import { useEffect } from 'react'

import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'

import { Cookie } from '../../../utils/cookies/Cookie'

/** Save sponsor key (uik) */
export const useSaveSponsorInfos = (uik: string | undefined) => {
  useEffect(() => {
    if (!getIsLoggedIn() && uik) {
      Cookie.set('latestUik', typeof uik === 'object' ? uik[0] : uik, 'oneYear')
    }
  }, [uik])
}
